import { createFileRoute } from "@tanstack/react-router";
import Index from "@/pages/Index";
import { publicToolHead } from "@/lib/publicToolRoutes";

const Page = () => <Index toolKey="proposals" routeLang="es" />;

export const Route = createFileRoute("/herramientas/proveedores")({
  head: () => publicToolHead("proposals", "es"),
  component: Page,
  errorComponent: Page,
  notFoundComponent: Page,
});
